import { Button } from '@/components/ui/button';
import { useAuth } from '@auth';
import { useSearchParams } from 'wouter';
import SplashLogo from '@/assets/icons/splash_screen_logo.svg?react';
import { SplashScreen } from '@/components/SplashScreen';

export default function Login() {
  const { signIn, signUp, isLoading } = useAuth();
  const [searchParams] = useSearchParams();

  let returnURI = searchParams.get('returnURI');
  returnURI = returnURI === '/login' ? '/' : returnURI;

  if (isLoading) {
    // we should debounce this, but this screen will go away
    // once we have a marketing site login
    return <SplashScreen />;
  }

  return (
    <div className="flex min-h-dvh flex-col items-center justify-between gap-16 p-6">
      <div className="flex flex-1 items-center justify-center self-stretch">
        <SplashLogo className="px-4" />
      </div>

      <div className="flex w-full flex-col justify-stretch gap-4">
        <Button onClick={() => signIn({ state: { returnTo: returnURI } })}>Sign in</Button>
        <Button onClick={signUp}>Sign up</Button>
      </div>
    </div>
  );
}
